/** Lectures de l'API gardées par le service worker ; le front les efface à la déconnexion. */
export const CACHE_DONNEES = 'mamarotte-donnees'
